/** Domain unit strings for metric display/formatting — single source shared by formatters, charts, utils. */
export const METRIC_UNIT = {
  PERCENT: "percent",
  PERCENT_100: "percent100",
  MS: "ms",
  SECONDS: "seconds",
  GB_SECONDS: "GB-seconds",
  GB_HOURS: "GB-hours",
  VCORE_HOURS: "vcore-hours",
  TIMESTAMP: "timestamp",
  BYTES: "bytes",
  BYTES_PER_SEC: "bytes/s",
  CURRENCY: "currency",
} as const;

/** Legacy API / payload spelling; distinct from `METRIC_UNIT.BYTES`. */
export const METRIC_UNIT_BYTES_LEGACY = "Bytes" as const;

/**
 * Pseudo-unit for a series divided by another metric (chart normalization). The ratio
 * carries neither side's unit, and lands orders of magnitude below the numerator, so the
 * unit formatters must not run on it: each stops at its own resolution and would report
 * every point as "0s" / "0 B" / "0" rather than as a small number.
 */
export const METRIC_UNIT_RATIO = "ratio" as const;

export const METRIC_VALUE_FORMATTER_UNITS = Object.values(METRIC_UNIT);
